import firebase from "firebase/app";
import "firebase/firestore";

const firebaseConfig = {
	apiKey: "AIzaSyDJa4CuFOW7QfeSUgusYjrHtggc9u4G2rc",
	authDomain: "dna-for-performance.firebaseapp.com",
	projectId: "dna-for-performance",
	storageBucket: "dna-for-performance.firebasestorage.app",
	messagingSenderId: "647647569668",
	appId: "1:647647569668:web:8fc287004146a746379251",
};

firebase.initializeApp(firebaseConfig);

const db = firebase.firestore();
export { db };
